import axios from 'axios'
import * as types from '../mutation-types'

// state
export const state = {
  countries: [],
  country: null,
  countryTotalItems: null
}

// mutations
export const mutations = {
  [types.SET_COUNTRIES] (state, payload) {
    payload.data ? state.countries = payload.data : state.countries = payload
    payload.data ? state.countryTotalItems = payload.total : state.countryTotalItems = null
  },
  [types.SET_COUNTRY] (state, country) {
    state.country = country
  },
  [types.FETCH_COUNTRY_FAILURE] (state) {
    state.country = null
  }
}

// actions
export const actions = {
  async fetchCountries ({ commit }, payload) {
    try {
      const { data } = await axios.get('/countries', {
        params: payload ? payload.query : ''
      })
      commit(types.SET_COUNTRIES, data)
    } catch (e) {
      console.log(e)
    }
  },
  async fetchCountry ({ commit }, country) {
    try {
      const { data } = await axios.get(`/countries/${country.id}`)

      commit(types.SET_COUNTRY, { country: data })
    } catch (e) {
      commit(types.FETCH_COUNTRY_FAILURE)
    }
  },

  async createCountry (context, country) {
    try {
      await axios.post('/api/countries', country)
      context.dispatch('fetchCountries')
    } catch (e) {
      console.log(e)
    }
  },

  async updateCountry (context, country) {
    try {
      await axios.put(`/api/countries/${country.id}`, country)
      context.dispatch('fetchCountries')
    } catch (e) { }
  },

  async deleteCountry (context, country) {
    try {
      await axios.delete(`/api/countries/${country.id}`)
      context.dispatch('fetchCountries')
    } catch (e) { }
  }
}

// getters
export const getters = {
  countries: state => state.countries,
  countryTotalItems: state => state.countryTotalItems
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/country.js